import { useRefresh } from 'react-admin';
import CheckIcon from '@mui/icons-material/Check';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { adminRpcClient } from '@/providers/backendClient';

type ForceAggregationProps = {
  sessionNote: any;
  recordings: any[];
};

export const ForceAggregationButton = ({
  sessionNote,
  recordings,
}: ForceAggregationProps) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const aggregateAvailable = useMemo(
    () =>
      recordings?.some(
        rec => rec.status === 'transcribed' && rec.transcript,
      ),
    [recordings],
  );

  const refresh = useRefresh();

  const onForceAggregation = useCallback(async () => {
    setIsUpdating(true);

    await adminRpcClient('PUBLIC_ADMIN_therapistAsset_aggregate', [
      sessionNote.id,
      'therapistSessionNotes',
    ]).catch(err => {
      alert(
        'Error aggregating aggregating Note inputs: ' + err.message,
      );
    });

    setIsUpdating(false);

    refresh();
  }, [refresh, sessionNote.id]);

  const onClose = useCallback(() => {
    setConfirmDialogOpen(false);
  }, []);

  return aggregateAvailable ? (
    <>
      <Button
        disabled={isUpdating}
        onClick={onForceAggregation}
        startIcon={
          !isUpdating ? (
            <CheckIcon />
          ) : (
            <CircularProgress size="1rem" />
          )
        }
      >
        {!isUpdating ? 'Force Aggregation' : 'Aggregating'}
      </Button>

      <Dialog open={confirmDialogOpen} onClose={onClose}>
        <DialogTitle>Force Aggregation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to force aggregation?
          </DialogContentText>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={onForceAggregation}>
              Force Aggregation
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  ) : null;
};
